// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}
	let scrollpos = window.scrollY;
	let header = document.getElementById("header");

	function add_class_on_scroll() {
	    header.classList.add("scroll");
	}

	function remove_class_on_scroll() {
	    header.classList.remove("scroll");
	}

	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 10) {
			add_class_on_scroll();
		} else {
			remove_class_on_scroll();
		}
	}

	$(document).ready(function () { 

		let home = document.querySelector('body#home')
		if (home) {
			scrollDownAction(10, 'scroll');
		} else {
			var logoHeader = document.querySelector('.js-scroll-logo img');
			var getLogoUrl;
			var getDataLogo;
			if (logoHeader.length !== 0) {
				getLogoUrl = logoHeader.src || [];
				getDataLogo = logoHeader.getAttribute('data-scroll');
				logoHeader.src = getDataLogo;
			}

		}


		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


		//Menu burger tablet
		$("#menu-btn").click(function(){
			$(this).toggleClass("active");
			$('#primary-nav').toggleClass("active");
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		var videoUrl;
		var square = false;
		$('.open-video2').click(function(event){
			event.preventDefault();
			videoUrl = $(this).attr('data-video');
			square = $(this).attr('data-square');
		})
		$('.open-video2').fancybox({
			afterShow	:	function() {
				$('#lightbox-video').attr('src',videoUrl);
				$('#lightbox-video')[0].play();
				if(square==false){
					$('.lightbox-video-content').removeClass('square');
				}else{
					$('.lightbox-video-content').addClass('square');
				}
			},
			overlayShow : true,
			centerOnScroll : true,
			speedIn : 100,
			speedOut : 50,
			allowfullscreen:true,
			width: '100%',
			height: '100%',
			autosize: false
		});
		$('#third-nav').removeAttr('aria-labelledby');
		$('#preloader').fadeOut('slow');
	});

}());